import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { Airline as oAirline, StopTable as oStopTable, Header as oHeader } from '../FlightsCompare/styles';

export const Airline = styled(oAirline)``;

Airline.Logo = styled.div`
  width: 16px;
  height: 16px;
  border: 1px solid ${ColorPalette.HEX.AntiFlashWhite3};
  margin-right: 10px;
`;

export const StopTable = styled(oStopTable)`
  & span {
    color: ${ColorPalette.Transparent};
  }
`;

export const Header = styled(oHeader)`
  border-color: rgba(${ColorPalette.RGB.PhilippineSilver}, 0.25);
`;
